import GalleryAboutTeamDetail from './about-team-detail/script';

export default {
	[GalleryAboutTeamDetail.selector]: GalleryAboutTeamDetail
};
